import axios from "axios";
import { apiDomain } from "../store/constants"

axios.defaults.withCredentials = true;
axios.defaults.baseURL = apiDomain;